
(function ($) {
   
//   $(document).ready(function () {
// 	if ($(window).width() <= 990) {
// 		$('.verticalMenu').hide();
// 		$(".toggle_sidebar").click(function () {
// 			$(".toggle_sidebar").removeClass("toggle_open")
// 			//$(".verticalMenu").slideUp("normal");
// 			if ($(this).next(".verticalMenu").is(':hidden') == true) {
// 				$(this).addClass("toggle_open");
// 				$(this).next(".verticalMenu").slideDown("normal")		
// 			}			
// 		});
// 	}
// });
$(document).ready(function() {
 
      
  if ($("body").hasClass("template-customers/addresses")){ 
      // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

   // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  }
      $('.delete-btn').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
     
  });
      
}(jQuery));